import React from 'react';
import { DialogActions, Button, Dialog, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import PropTypes from 'prop-types';

const DefaultDialog = (props) => {
  const { color = 'primary', size = 'small', style = null, btnString, disabled = false, title, description, disagreeBtnStr = 'Disagree', agreeBtnStr = 'Agree', handleAgree, isLoading } = props;
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAgreeAction = () => {
    setOpen(false);
    handleAgree();
  };

  return (
    <React.Fragment>
      <Button variant="contained" disabled={disabled} size={size} color={color} style={style} onClick={handleClickOpen}>
        {btnString}
      </Button>
      <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{description}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {disagreeBtnStr}
          </Button>
          <Button onClick={handleAgreeAction} disabled={isLoading} color="primary" autoFocus>
            {agreeBtnStr}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

DefaultDialog.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  disagreeBtnStr: PropTypes.string,
  agreeBtnStr: PropTypes.string,
  btnString: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  handleAgree: PropTypes.func.isRequired,
};

export default DefaultDialog;
